/*
 * Sold-in-multiples quantity enforcement.
 *
 * snippets/quantity-selector.liquid puts data-quantity-multiple (plus matching min/step) on the
 * input for box2-tagged products. Empire's QuantitySelector only steps the +/- buttons by the
 * increment, so typed values need rounding here:
 *   - keyup is held back: Empire pushes every keystroke to the cart (keyup -> onChange -> change.js)
 *   - on change, the value is rounded UP to the next multiple before Empire's own change handler reads it
 *   - on /cart, lines that arrived odd by another path (reorder, pre-fix carts) are corrected once
 * Capture-phase listeners on document run before Empire's element-level handlers. Never edit empire.js.
 */
(function () {
  var SEL = 'input[data-quantity-multiple]';

  function multiple(input) {
    return parseInt(input.getAttribute('data-quantity-multiple'), 10) || 1;
  }

  function roundedUp(input) {
    var m = multiple(input);
    var v = parseInt(input.value, 10);
    return v > 0 && v % m ? v + m - (v % m) : v;
  }

  function isTarget(e) {
    return e.target && e.target.matches && e.target.matches(SEL);
  }

  document.addEventListener('keyup', function (e) {
    if (isTarget(e)) e.stopPropagation();
  }, true);

  document.addEventListener('keydown', function (e) {
    if (isTarget(e) && e.key === 'Enter') e.target.blur(); // commit -> change
  }, true);

  document.addEventListener('change', function (e) {
    if (!isTarget(e)) return;
    var v = roundedUp(e.target);
    if (v !== parseInt(e.target.value, 10)) e.target.value = v;
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    var odd = Array.prototype.filter.call(document.querySelectorAll(SEL + '[name="updates[]"]'), function (input) {
      return roundedUp(input) !== parseInt(input.value, 10);
    });
    if (!odd.length) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    odd.reduce(function (chain, input) {
      var row = input.closest('[data-cartitem-key]');
      var key = row && row.getAttribute('data-cartitem-key').trim();
      var qty = roundedUp(input);
      return chain.then(function (ok) {
        if (!ok || !key) return false;
        return fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        }).then(function (r) {
          return r.ok ? r.json() : null;
        }).then(function (cart) {
          // Only a confirmed even line may trigger the reload, so an inventory cap can never loop it.
          var line = cart && cart.items.filter(function (i) { return i.key === key; })[0];
          return !!line && line.quantity % multiple(input) === 0;
        });
      });
    }, Promise.resolve(true)).then(function (ok) {
      if (ok) window.location.reload();
    });
  });
})();
